import { format as formatDT, parseISO } from "date-fns";
import { truncate } from "htmlsave";
import { Immutable } from "immer";
import React from "react";
import { DisclosureCopy } from "tsi-common-react/src/apps/reviews/DisclosureCopy/index";
import { RatingGraphic } from "tsi-common-react/src/components/RatingGraphic/index";
import { IReview } from "tsi-common-react/src/models/reviews";

import styles from "./index.module.scss";

type IProps = Immutable<{
    review: IReview;
}>;

export const Review = ({ review }: IProps): React.ReactNode => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const onExpand = (evt: React.MouseEvent<HTMLElement>) => {
        evt.preventDefault();
        setIsExpanded(true);
    };

    const buildContent = () => {
        if (isExpanded) {
            return (
                <div className={styles.text}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: review.text,
                        }}
                    ></span>
                </div>
            );
        }
        const truncatedContent = truncate(review.text, 420, {
            ellipsis: "…",
        });
        return (
            <div className={styles.text}>
                <span
                    dangerouslySetInnerHTML={{ __html: truncatedContent }}
                ></span>
                {truncatedContent.indexOf("…") ===
                    truncatedContent.length - 1 && (
                    <button
                        className={styles.showFull}
                        onClick={(evt) => {
                            onExpand(evt);
                        }}
                    >
                        {/* TODO(i18n): Use t tagged template for button text: {t`Read More`} */}
                        &nbsp;Read More
                    </button>
                )}
            </div>
        );
    };

    return (
        <div className={styles.viewReview}>
            <div className={styles.starsReview}>
                <span className={styles.starsReviewStars}>
                    <RatingGraphic
                        cardClass="reviews"
                        cardSize="large"
                        onlyStars={true}
                        rating={review.rating}
                        starHasStroke={true}
                    />
                </span>
                <span className={styles.starsReviewProductName}>
                    {review.product_name}
                </span>
            </div>
            <h2 className={styles.viewReviewTitle}>{review.headline}</h2>
            <div className={styles.userInfo}>
                {/* TODO(i18n): Use t to keep complete sentence together with interpolation instead of splitting name/location/date: {t`${name}, ${location} - ${date}`} */}
                {/* TODO(i18n): Date format "MM/dd/yy" is US-specific and should be locale-aware */}
                <span className={styles.userInfoName}>{review.name},</span>
                &nbsp;
                <span className={styles.userInfoLocationDate}>
                    {review.location} -{" "}
                    {formatDT(parseISO(review.created_datetime), "MM/dd/yy")}
                </span>
            </div>
            {buildContent()}
            <DisclosureCopy review={review} />
            <div className={styles.footer}></div>
        </div>
    );
};
